// extracted by mini-css-extract-plugin
export default {"darkInputColor":"#fff","darkInputPlaceholderColor":"#bac0ce","lightInputColor":"#465057","lightInputPlaceholderColor":"#b6b8b8"};